import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '@done/ngx-essentials';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }

  list(): Observable<User[]> {
    return this.http.get<User[]>(`${environment.apiGateway}/auth/users/all`);
  }

  // listByIds(ids: number[]): Observable<User[]> {
  //   return this.http.post<User[]>(`${environment.apiGateway}/users/external/listuserbyids`, ids);
  // }

  findById(id: string): Observable<User> {
    return this.http.get<User>(`${environment.apiGateway}/auth/users/${id}`);
  }

  findByEmail(email: string): Observable<User> {
    return this.http.get<User>(`${environment.apiGateway}/auth/users/find/${email}`);
  }

  findAlcadaApontamentos(userId: string, accountId: number): Observable<string> {
    return this.http.get<string>(`${environment.apiGateway}/auth/accountsUsers/find-alcada-pointer/${userId}/${accountId}`, {
      responseType: "string" as any
    });
  }

  // listUserbyAccessGroupIds(ids: number[]): Observable<User[]> {
  //   return this.http.post<User[]>(`${environment.apiGateway}/users/external/listUserbyAccessGroupIds`, ids);
  // }
}
